import React from 'react';
import { Section } from './ui/Section';
import { PricingCard } from './PricingCard';
import { CtaFrame } from './ui/CtaFrame';
import { UrgencyBadge } from './ui/UrgencyBadge';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
import { Shield, CreditCard, Star } from 'lucide-react';
import { Divider } from './botanical/Divider';
export function CTA1() {
  return <Section className="bg-forest-mist pt-0" data-id="element-144">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-145">
        <CtaFrame variant="forest" className="mb-8" data-id="element-146">
          <div className="flex justify-center mb-6" data-id="element-147">
            <UrgencyBadge variant="fire" tone="light" label="ELEGÍ TU PLAN AHORA" data-id="element-148" />
          </div>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-149">
            <PricingCard title="HOGAR NATURAL" price="$17.999" buttonText="QUIERO EMPEZAR HOY" href={CHECKOUT_URLS.hogarNatural} data-id="element-150" />
            <PricingCard title="SUPER PACK" price="$27.999" buttonText="QUIERO EL PACK COMPLETO" href={CHECKOUT_URLS.superPack} isPopular data-id="element-151" />
          </div>
        </CtaFrame>

        <div className="flex flex-col items-center justify-center gap-4 text-sm text-forest/70" data-id="element-152">
          <div className="flex items-center gap-4 flex-wrap justify-center" data-id="element-153">
            <span className="flex items-center gap-1.5" data-id="element-154">
              <Shield className="w-4 h-4 text-moss" data-id="element-155" /> Garantía 7 días
            </span>
            <span className="hidden sm:inline text-sage-deep" data-id="element-156">•</span>
            <span className="flex items-center gap-1.5" data-id="element-157">
              <CreditCard className="w-4 h-4 text-moss" data-id="element-158" /> Pago seguro
            </span>
            <span className="hidden sm:inline text-sage-deep" data-id="element-159">•</span>
            <span className="font-medium text-forest-deep" data-id="element-160">Mercado Pago</span>
          </div>

          <div className="flex items-center gap-3 flex-wrap justify-center font-medium bg-white/80 backdrop-blur-sm px-6 py-2 rounded-full shadow-sm border border-sage-mist" data-id="element-161">
            <span className="text-forest-deep" data-id="element-162">+800 familias</span>
            <span className="text-sage-deep" data-id="element-163">•</span>
            <span className="text-forest-deep" data-id="element-164">5 Tomos</span>
            <span className="text-sage-deep" data-id="element-165">•</span>
            <span className="text-forest-deep" data-id="element-166">5 Bonos</span>
            <span className="text-sage-deep" data-id="element-167">•</span>
            <span className="flex items-center gap-1 text-forest-deep" data-id="element-168">
              4.9/5 <Star className="w-4 h-4 fill-honey text-honey" data-id="element-169" />
            </span>
          </div>
        </div>
      </div>
      <Divider className="mt-16" data-id="element-170" />
    </Section>;
}